import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollFMYExportDetail  {
    _originalTypeClassName = "zERP.BO.PayrollFMYExportDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollFMYExportDetail.translate = translateService;
}
this.Employees = [];
this.Id = null;
this.DateCreated = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateCreated:any;
PayrollFMYExport:any;
Employees:any;
File:any;
static setPayrollFMYExport = ($this, value) => {
var oldValue = $this.PayrollFMYExport;
$this.PayrollFMYExport = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollFMYExport.removeDetails(oldValue, $this);
}
Domain.PayrollFMYExport.addDetails(value, $this);
}
}
static setEmployees = ($this, items) => {
                if (items == null) items = [];
                if ($this.Employees == null) $this.Employees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Employees.length > 0) {
                    Domain.PayrollFMYExportDetail.removeEmployees($this, $this.Employees[0]);
                }

                Domain.PayrollFMYExportDetail.addManyEmployees($this, copyItems);
            }
static addManyEmployees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollFMYExportDetail.addEmployees($this, items[i]);
                }
            }
static addEmployees = ($this, item) => {
                if ($this.Employees == null) $this.Employees = [];
                if (item == null || $this.Employees.indexOf(item) > -1) return;
                $this.Employees.push(item);
if (item.PayrollFMYExportDetail != $this) {
Domain.EmployeePayroll.setPayrollFMYExportDetail(item, $this);
}
}
static addRangeEmployees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollFMYExportDetail.addEmployees($this, item));
            }
static removeEmployees = ($this, item) => {
                if ($this == null || $this.Employees == null || $this.Employees.indexOf(item) === -1) return;
                var _index = $this.Employees.indexOf(item);
                $this.Employees.splice(_index, 1);
item.PayrollFMYExportDetail = null;
}
static clearEmployees = ($this) => { $this.Employees = null; }
static setFile = ($this, value) => {
var oldValue = $this.File;
$this.File = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}